import axios from "../plugins/axios";

export default {
  getByIdAndClassOrType(id, type, className = "") {
    return axios.post("/web_api/v1/has_attachable", {
      has_attachable_id: id,
      has_attachable_type: type,
      has_attachable_class: className,
    }).then((response) => response.data);
  },
};
